export default __webpack_public_path__ + "static/media/Care04.d0e45a0e.png";